export default __webpack_public_path__ + "static/media/Skills.3bca11a7.png";